export const PROFILE_GET_PROFILE_BEGIN = 'PROFILE_GET_PROFILE_BEGIN';
export const PROFILE_GET_PROFILE_SUCCESS = 'PROFILE_GET_PROFILE_SUCCESS';
export const PROFILE_GET_PROFILE_FAILURE = 'PROFILE_GET_PROFILE_FAILURE';
export const PROFILE_GET_PROFILE_DISMISS_ERROR = 'PROFILE_GET_PROFILE_DISMISS_ERROR';
export const PROFILE_UPDATE_PERSON_INFO_BEGIN = 'PROFILE_UPDATE_PERSON_INFO_BEGIN';
export const PROFILE_UPDATE_PERSON_INFO_SUCCESS = 'PROFILE_UPDATE_PERSON_INFO_SUCCESS';
export const PROFILE_UPDATE_PERSON_INFO_FAILURE = 'PROFILE_UPDATE_PERSON_INFO_FAILURE';
export const PROFILE_UPDATE_PERSON_INFO_DISMISS_ERROR = 'PROFILE_UPDATE_PERSON_INFO_DISMISS_ERROR';
export const PROFILE_SET_LOADING = 'PROFILE_SET_LOADING';
export const PROFILE_UPDATE_PASSWORD_BEGIN = 'PROFILE_UPDATE_PASSWORD_BEGIN';
export const PROFILE_UPDATE_PASSWORD_SUCCESS = 'PROFILE_UPDATE_PASSWORD_SUCCESS';
export const PROFILE_UPDATE_PASSWORD_FAILURE = 'PROFILE_UPDATE_PASSWORD_FAILURE';
export const PROFILE_UPDATE_PASSWORD_DISMISS_ERROR = 'PROFILE_UPDATE_PASSWORD_DISMISS_ERROR';
export const PROFILE_SET_LOADING_PASSWORD = 'PROFILE_SET_LOADING_PASSWORD';
export const PROFILE_UNSET_LOADING_PASSWORD = 'PROFILE_UNSET_LOADING_PASSWORD';
export const PROFILE_UPLOAD_AVATAR_BEGIN = 'PROFILE_UPLOAD_AVATAR_BEGIN';
export const PROFILE_UPLOAD_AVATAR_SUCCESS = 'PROFILE_UPLOAD_AVATAR_SUCCESS';
export const PROFILE_UPLOAD_AVATAR_FAILURE = 'PROFILE_UPLOAD_AVATAR_FAILURE';
export const PROFILE_UPLOAD_AVATAR_DISMISS_ERROR = 'PROFILE_UPLOAD_AVATAR_DISMISS_ERROR';



// WEBPACK FOOTER //
// ./src/features/profile/redux/constants.js